import FadeInSection from "../components/FadeInSection";

import { useEffect } from "react";

const Aboutus = () => {
    useEffect(() => {
        const page = document.getElementById('aboutuspage');
        page.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    const pillars = [
        {
            icon: "git-network-outline",
            title: "Systems Integration",
            description: "Designing and deploying end-to-end integrated IT solutions for public and private organizations."
        },
        {
            icon: "shield-checkmark-outline",
            title: "Cybersecurity & Assurance",
            description: "Vulnerability assessment, penetration testing, and compliance-driven security engagements."
        },
        {
            icon: "code-slash-outline",
            title: "Software Engineering",
            description: "Custom software built to fit real operations — from fleet and fare collection to HR and events."
        },
        {
            icon: "settings-outline",
            title: "Managed IT Services",
            description: "Dependable outsourced IT support and operations backed by seasoned specialists."
        }
    ];

    const values = [
        { icon: "people-outline", label: "Collaboration" },
        { icon: "ribbon-outline", label: "Integrity" },
        { icon: "bulb-outline", label: "Innovation" },
        { icon: "heart-outline", label: "Client Partnership" }
    ];

    return (
        <div id="aboutuspage" className="aboutuspage">
            <div className="page-header">
                <div className="container d-flex justify-content-center align-items-center flex-column">
                    <h1 className='fw-bold text-center'>About Us</h1>
                </div>
            </div>
            <div className="container p-100 text-justify px-2">
                <FadeInSection direction="bottom">

                    <div className="company-tagline text-center mt-5">
                        <h2 className="text-center m-0 fw-bolder fs-1">
                            BUILDING TECHNOLOGIES, <br />
                            INSPIRING INNOVATIONS
                        </h2>
                    </div>
                    <div className="about-introduction-bg mt-5">
                        <p className="m-0">
                            Euodoó Technologies, Inc. is the culmination of over fifteen (15) years of
                            extensive experience in the Information Technology (IT) Solutions and Services
                            industry. Formerly known as Innovare Tekhne, this spin-off company now
                            specializes in Systems Integration (SI) products and IT-managed services.
                        </p>
                    </div>

                    <div className="about-introduction mt-5 mb-2">
                        <p className="mb-3">
                            Euodoó Tech offers a comprehensive range of IT solutions, focusing on key
                            areas such as Fleet Management System, Automated Fare Collection System,
                            Vulnerability Assessment and Penetration Testing, Anti-Money Laundering System,
                            Visitor Management System, Event Management System, Human Resource Information
                            System, customized software development, and outsourced IT solutions and services
                            for both public and private entities. With a strong management team, highly skilled
                            IT professionals, and dependable solution partners, Euodoó Tech takes pride in delivering
                            exceptional technical expertise and competency. The company has secured accreditation
                            from Dun & Bradstreet (D&B), confirming its compliance with the Vendor
                            Integrity Access (VIA) requirements.
                        </p>
                        <p className="m-0">
                            Guided by the viewpoint, “Building Technologies. Inspiring Innovations,” Euodoó Tech
                            employs a distinctive and strategic approach to understanding and assessing critical IT
                            solutions that empower clients to achieve competitive edge. The company believes that the
                            success and efficiency of any IT solution depend on the collaborative efforts of both
                            the solution provider and the client. As a dedicated partner, Euodoó Tech remains responsive
                            to the evolving technology landscape and the dynamic nature of the business environment.
                        </p>
                    </div>
                </FadeInSection>

                <div className="about-team overflow-hidden mt-5">
                    <FadeInSection direction="bottom">
                        <h2 className="fw-bold text-center mb-3">Our Team</h2>
                        <p className="about-team__subtitle text-center mx-auto">
                            A collective of engineers, consultants, and specialists united by a shared
                            commitment to delivering dependable, well-crafted IT solutions.
                        </p>
                    </FadeInSection>

                    <FadeInSection direction="bottom">
                        <div className="about-stats row justify-content-center">
                            <div className="col-12 col-md-5">
                                <div className="about-stats__tile text-center">
                                    <div className="about-stats__number">Since 2018</div>
                                    <div className="about-stats__label">Euodoó Technologies, Inc.</div>
                                </div>
                            </div>
                            <div className="col-12 col-md-5">
                                <div className="about-stats__tile text-center">
                                    <div className="about-stats__number">15+ years</div>
                                    <div className="about-stats__label">of collective IT expertise</div>
                                </div>
                            </div>
                        </div>
                    </FadeInSection>

                    <FadeInSection direction="bottom">
                        <div className="about-pillars row">
                            {pillars.map((pillar) => (
                                <div key={pillar.title} className="col-12 col-sm-6 col-lg-3 d-flex">
                                    <div className="about-pillar w-100">
                                        <div className="about-pillar__icon">
                                            <ion-icon name={pillar.icon}></ion-icon>
                                        </div>
                                        <div className="about-pillar__title">{pillar.title}</div>
                                        <div className="about-pillar__desc">{pillar.description}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </FadeInSection>

                    <FadeInSection direction="bottom">
                        <div className="about-values">
                            {values.map((item) => (
                                <div key={item.label} className="about-values__item">
                                    <ion-icon name={item.icon}></ion-icon>
                                    <span>{item.label}</span>
                                </div>
                            ))}
                        </div>
                    </FadeInSection>

                    <FadeInSection direction="bottom">
                        <p className="about-closing text-center mx-auto">
                            Every engagement is a partnership. Together, we build technologies that endure
                            and inspire the innovations that move our clients forward.
                        </p>
                    </FadeInSection>
                </div>
            </div>
        </div>
    )
}

export default Aboutus;
